<template>
  <div>
    <!-- toasts message -->
        <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <v-progress-circular v-if="Loader" :size="70" :width="7" color="teal" indeterminate></v-progress-circular>
<!-- {{formSchema}} -->
    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->
      <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md>
          <v-layout wrap>
           <v-flex xs12 sm6 md4>								
						<v-text-field label="Training Title" v-model="formSchema.training_title" :rules="[v => !!v || 'Title is required']"></v-text-field>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						<v-select
                  label="Training Category"
                  v-model="formSchema.training_cat_id"
                  item-text="name"
                  item-value="id"
                  :items="items"
                  :rules="[v => !!v || 'Category is required']"
                ></v-select>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						<v-select
                  label="Training Type"
                  v-model="formSchema.training_type"
                  item-text="name"
                  item-value="name"
                  :items="[{name:'Local'},{name:'Foreign'},{name:'Online'}]"
                  :rules="[v => !!v || 'Type is required']"
                  
                ></v-select>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						<v-select
                  v-model="formSchema.is_open"
                  label="Status(Plan/Open/Close)"
                  item-text="name"
                  item-value="id"
                  :items="[{id:1,name:'Open'},{id:2,name:'Close'},{id:3,name:'Plan'}]"
                  :rules="[v => !!v || 'Field is required']"
                  @change="setTitle(formSchema.is_open)"
                ></v-select>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						<v-text-field label="Training Venue" v-model="formSchema.venue" :rules="[v => !!v || 'Venue is required']"></v-text-field>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
					<v-select
            v-if="is_plan"
            label="Organizer Name"
            item-text="name"
            item-value="id"
            v-model="formSchema.plan_organizer"
            :items="organizer" 
            multiple
          ></v-select>
          <v-select
            v-else
            label="Organizer Name"
            item-text="name"
            item-value="id"
            v-model="formSchema.organizer_id"
            :items="organizer"
          ></v-select>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						 <DatePicker
                :key="formSchema.id"
                :inputData="{index:1,fieldName:'start_date', fieldValue:formSchema.start_date, label:formDate }"
                @setValue="setDateValue"
              ></DatePicker>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						 <DatePicker
                :key="formSchema.id"
                :inputData="{index:2,fieldName:'end_date', fieldValue:formSchema.end_date, label:toDate, disabled:'1'}"
                @setValue="setDateValue"
                ref="setRange"
              ></DatePicker>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						<v-text-field :label="gobFund" v-model="formSchema.GoB_amount" :rules="[rules.decimalOnly]"></v-text-field>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						<v-text-field :label="idaFund" v-model="formSchema.ida_amount" :rules="[rules.decimalOnly]"></v-text-field>
					 </v-flex>
           <v-flex xs12 sm6 md4 v-if="is_plan">								
						<v-text-field label="Number Of Participants" v-model="formSchema.participant" :rules="[rules.decimalOnly]"></v-text-field>
					 </v-flex>
           <v-flex xs12 sm6 md4 v-if="is_plan">								
						<v-text-field label="Target Groups" v-model="formSchema.tr_group" ></v-text-field>
					 </v-flex>
          </v-layout>
           
        </v-container>
      </v-card-text>
    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" 
      @click="submitOperationActivities" 
      :disabled="buttonDisable"
      >
        {{buttonTitle}} 
        <v-icon> save</v-icon>
      </v-btn>
      <v-btn color="error" @click="reset">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn color="warning" @click="nextStep" v-show="showNext">
        Next
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
import DatePicker from "../../../global/date_picker";
import {store} from "../../../../vuex/store";
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      buttonDisable: false,
      valid: true,
      e1: 0,
      show: false,
      Loader: false,
      SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
      is_plan: false,
    },
      is_plan : false,
      formDate : "Training Start Date",
      toDate : "Training End Date",
      idaFund : "IDA Fund (BDT)",
      gobFund : "GOB Fund (BDT)",
      checkboxVal:1,
      training_info_id: sessionStorage.getItem("training_info"),
      snackbar: false,
      color: "success",
      mode: "",
      timeout: 3000,
      left: "left",
      message: "",
      dialog2:false,
      rules: {
        decimalOnly: value => {
          if (value && value.length > 0) {
          const pattern = /^\d+(\.\d)?\d*$/;
          return pattern.test(value) || "Invalid number";
        } else {
          return true;
        }
        },
        
      },
      items:[],
      organizer:[],
      formSchema: {
        id: 0,
        operation_id:"",
        training_code:"",
        training_title: "",
        training_cat_id: "",
        training_type: "",
        is_open: "",
        venue: "",
        organizer_id: "",
        plan_organizer: [],
        start_date:"",
        end_date: "",
        ida_amount: "",
        GoB_amount: "",
        participant:"",
        tr_group:""

      }
    };
  },

  created() {
    if(this.training_info_id)   
    {
      this.loadData();
    }   
  },
  computed:{
    buttonTitle(){
      return sessionStorage.getItem("training_info") > 0 ? 'Update ' : 'Save '
    },
    showNext(){
      if(this.formSchema.id > 0){
        return true
      }
    }
  },
  methods: {
    setTitle(title){
      if(title == 3){
        this.formDate = 'Tentative Start Date';
        this.toDate = 'Tentative End Date';
        this.idaFund = 'Budget IDA Fund (BDT)';
        this.gobFund = 'Budget GOB Fund (BDT)';
        this.is_plan = true;
      }else{
        this.formDate = 'Training Start Date';
        this.toDate = 'Training End Date';
        this.idaFund = 'IDA Fund (BDT)';
        this.gobFund = 'GOB Fund (BDT)';
        this.is_plan = false;
      }
    },
    setDateValue(data) {
      let index = data.index;
      this.formSchema[data.fieldName] = data.value;

      if(data.fieldName == "start_date"){
        this.formSchema.end_date = 0
        this.$refs.setRange.setRange(data.value);
      }
    },

    submitOperationActivities() {
      
     if (this.$refs.form.validate()) {  
          //button disale
          this.buttonDisable = true;  

          this.submitForm();
          
          // Re-enable after 3 seconds
          this.timeout = setTimeout(() => {
            this.buttonDisable = false
          }, 3000)
      };

    },

    submitForm() {
     
      let root = this;
      this.Loader = true;
      let formSchema = this.formSchema;

      formSchema.start_date = formSchema.start_date == "" ? "" : formSchema.start_date == null ? "": root.changeFormateYMD(
        formSchema.start_date
        );
      formSchema.end_date = formSchema.end_date == "" ? "" : formSchema.end_date == 0 ? "": formSchema.end_date == null ? "": root.changeFormateYMD(
        formSchema.end_date
        );
        formSchema.plan_organizer = JSON.stringify(formSchema.plan_organizer);
  
          if ( formSchema.id > 0 )
          {            
              commonService.updateFormData(formSchema, 'training_info').then(res => {							
							if(res.status == 1){
                 this.SnackbarVal.color = 'success';
                 this.SnackbarVal.message = res.message;
                 this.SnackbarVal.snackbar = true;
                // sessionStorage.removeItem("training_info"),
                // this.formSchema = {}
                // this.$emit('reloadData')
                setTimeout(function() {
                  root.nextStep();
                }, 3000); 
							}
						});
            
          }
          else
          {            
            commonService.insertFormData(formSchema, 'training_info').then(res => {							
							if(res.status == 1){
                this.SnackbarVal.color = 'success';
                 this.SnackbarVal.message = res.message;
                 this.SnackbarVal.snackbar = true;
                sessionStorage.setItem("training_info", res.data.id); 
                this.$store.commit('updateTrainingId', res.data.id)
                this.$emit('setTrainingId', res.data.id)
                setTimeout(function() {
                  root.nextStep();
                }, 3000);
 
							}
						});
            
          }
        
              
    },

    nextStep() {
      if (this.$refs.form.validate()) {        
         this.Loader = false;  
         this.$emit("emitForm1", 2);
      };
    },

    previous() {
      this.$emit("emitForm1", 1);
    },

    close: function() {
      this.$refs.form.reset();
    },
    reset(){
       if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }
    },
    getTrainingCategory(){
       commonService.getAllData('get_category').then(res => {  
                    this.items = res.data;
              });   
    },
    getTrainingOrganizer(){
       commonService.getAllData('get_training_organizer').then(res => {  
                    this.organizer = res.data;
              });   
    },
    loadData() {
      let formSchema = this.formSchema;
      commonService
        .getAllDataById(this.training_info_id, "training_info")
        .then(res => {
          if (res.data) {
            this.formSchema = res.data;
        
            this.formSchema.start_date = this.changeFormateDMY(
              res.data.start_date
            );
            this.formSchema.end_date = this.changeFormateDMY(
              res.data.end_date
            );
            this.formSchema.plan_organizer = JSON.parse(res.data.plan_organizer);
            console.log('', formSchema.plan_organizer);  
            if (res.data.is_open == false){
                this.formSchema.is_open = 2
            }
            this.setTitle(res.data.is_open);
            
            
          }
          this.show = true;
        });
    },

  },
  mounted(){
    this.getTrainingCategory();
    this.getTrainingOrganizer();

  }
};

</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
  position: absolute !important;
  left: 37%;
}
</style>


// WEBPACK FOOTER //
// src/components/training/training_information/step_forms/trainingInfoForm.vue